import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body, html {
      overflow-x: clip;
      overflow: visible;
    }
    body {
      margin: 0;
      padding: 0;
      background-color: #FFFFFF;
      font-family: Inter;
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none;
      outline: none !important;
      position: relative;
    }
    header {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 50;
    }
    select {
      outline: none !important;
    }
    button, label, a {
      user-select: none;
      position:relative;
    }
    .touchable-highlight {
      -webkit-tap-highlight-color: white;
    }
`;

export default GlobalStyle;
